import { useState, useCallback } from "react";
import { getActiveFilters } from "./get-active-filters";
export var useFilterState = function (criteria, filters) {
    var _a = useState(function () { return getActiveFilters(criteria, filters !== null && filters !== void 0 ? filters : {}); }), activeFilters = _a[0], setActiveFilters = _a[1];
    var refreshAllFilters = useCallback(function (criteria) {
        setActiveFilters(criteria ? getActiveFilters(criteria, filters !== null && filters !== void 0 ? filters : {}) : []);
    }, [filters]);
    var updateFilters = useCallback(function (filterIds, criteria) {
        return setActiveFilters(function (state) {
            if (filterIds === null || filterIds === void 0 ? void 0 : filterIds.length) {
                var changed_1 = false;
                var newState_1 = state.slice();
                filterIds.forEach(function (filterId) {
                    var filter = filters === null || filters === void 0 ? void 0 : filters[filterId];
                    if (filter) {
                        var hasValue = filter.hasValue(criteria);
                        var index = newState_1.indexOf(filterId);
                        if (index < 0 && !hasValue) {
                            return;
                        }
                        changed_1 = true;
                        if (index >= 0) {
                            newState_1.splice(index, 1);
                        }
                        if (hasValue) {
                            newState_1.push(filterId);
                        }
                    }
                });
                if (changed_1) {
                    return newState_1;
                }
            }
            return state;
        });
    }, [filters]);
    return { activeFilters: activeFilters, updateFilters: updateFilters, refreshAllFilters: refreshAllFilters };
};
//# sourceMappingURL=use-filter-state.js.map